import React from 'react';
import UIComponent from 'ui-components/ui-component';
import EventCenter from 'global-libs/old-event/event-center';
import Image from 'ui-components/image/image';
import Config from 'global-libs/config/config';
//@resJson:{
// "res_type_id":"1",
// "resource_type":"仿真工具",
// "res_id":"1",
// "name":"光的反射",
// "guid":"o_1bgng560c1hglm4omq14ib11kgc",
// "ext":"",
// "preview_ext":"jpg"}
//@index:用来随机背景颜色
let radomColor = ["#2980b9",
    "#d35400",
    "#16a085",
    "#c0392b"];
class ResPreview extends UIComponent{
    get className(){
        return "res-preview";
    }
    get isRegisterEvent(){
        return false;
    }
    get resJson(){
        return this.props.resJson;
    }
    get resPathRoot(){
        return Config.getConfig("resPathRoot");
    }
    get previewUrl(){
        let resJson = this.resJson;
        // return this.resPathRoot + resJson["guid"]+"/preview."+resJson["preview_ext"];
        return resJson["thumb"];
    }
    get name(){
        return this.resJson["name"];
    }
    get type(){
        return this.resJson["res_type_id"];
    }
    get ext(){
        return this.resJson["ext"];
    }
    //******针对工具和图片**************************************************
    get url(){
        return this.resJson['url']
        // let resName = "index.html";
        // if(this.type==3){
        //     resName = "image."+this.ext;
        // }
        // return this.resPathRoot + this.resJson["guid"]+"/"+resName;
    }
    //******针对视频**************************************************
    get urls(){
        let urls = [];
        if(this.type==2){
            // let exts = this.ext.split(",");
            // exts.forEach((item)=>{
            //     urls.push(this.resPathRoot + this.resJson["guid"]+"/video."+item);
            // });
            urls.push(this.resJson['url']);
        }
        // console.log(urls);
        return urls;
    }
    getChildren(){
        return [
            <span className="name" key="name" style={{backgroundColor:radomColor[this.props.index%4]}}>{this.name}</span>,
            <Image src={this.previewUrl} key="image" extraClass="image" onClick={()=>{
                EventCenter.fire({
                    type:"show-res",
                    res_type:this.type,
                    url:this.url,
                    urls:this.urls,
                    resName:this.name
                })
            }}/>
        ];
    }
}


export default class ResContainer extends UIComponent{
    awake(){
        super.awake();
        EventCenter.addEventListener("refresh-res",(e)=>{
            this.setState({res:e.data});
        });
    }
    get className(){
        return "res-container";
    }
    get isRegisterEvent(){
        return false;
    }
    initState(){
        let state = super.initState();
        state.res = [];
        return state;
    }
    getChildren(){
        let children = [];
        this.state.res.forEach((item,index)=>{
            children.push(<ResPreview resJson={item} key={"preview-"+index} index={index}/>);
        });
        return children;
    }
}
